/* lib/api/menus.js — REST-клиент /api/menus/* (порт из frontend/src/lib/api/menus.js).
 * Все ответы — {ok,status,data}. Меню server-authoritative и per-op:
 *  - членство блюд: PATCH меню { dishes: [{ttk_id}] } (полный replace);
 *  - раздел/порядок/стоп-лист: POST reorder { layout: [{ttk_id,section_id,order,in_stop_list}] };
 *  - разделы: CRUD + sections/reorder; стиль/мета: PATCH меню; экспорт/печать: GET /print/?fmt=.
 * Конвертацию decimal-строк и форму detail скрывает lib/adapters/menus.js. */
import { apiFetch } from './client.js';

export const listMenus = (params = {}) => {
  const q = new URLSearchParams();
  if (params.status) q.set('status', params.status);
  if (params.q) q.set('q', params.q);
  const qs = q.toString();
  return apiFetch(`/api/menus/${qs ? `?${qs}` : ''}`);
};

export const getMenu = (id) => apiFetch(`/api/menus/${id}/`);

export const createMenu = (body) =>
  apiFetch('/api/menus/', { method: 'POST', body });

export const updateMenu = (id, body) =>
  apiFetch(`/api/menus/${id}/`, { method: 'PATCH', body });

// F41: cascade=true — удалить и блюда, которые входили ТОЛЬКО в это меню
// (бэк вернёт {deleted_dishes, skipped[]} вместо 204).
export const deleteMenu = (id, { cascade = false } = {}) =>
  apiFetch(`/api/menus/${id}/${cascade ? '?cascade=dishes' : ''}`, { method: 'DELETE' });
// F41 — массовое удаление меню (multi-select). cascade — удалять и блюда,
// входившие только в эти меню.
export const bulkDeleteMenus = (ids, { cascade = false } = {}) =>
  apiFetch('/api/menus/bulk-delete/', { method: 'POST', body: { ids, cascade } });

// Глубокая копия меню (разделы + позиции + стиль) → MenuDetailSerializer копии.
export const duplicateMenu = (id) =>
  apiFetch(`/api/menus/${id}/duplicate/`, { method: 'POST' });

// Раскладка по разделам (through-модель MenuDish): section/order/in_stop_list.
// layout: [{ ttk_id, section_id: number|null, order, in_stop_list?: bool }, ...]
export const reorderMenu = (id, layout) =>
  apiFetch(`/api/menus/${id}/reorder/`, { method: 'POST', body: { layout } });

// ── Разделы блюд меню (MenuSection) ──────────────────────────────────────────
export const listSections = (menuId) =>
  apiFetch(`/api/menus/${menuId}/sections/`);

export const createSection = (menuId, body) =>
  apiFetch(`/api/menus/${menuId}/sections/`, { method: 'POST', body });

export const updateSection = (menuId, sectionId, body) =>
  apiFetch(`/api/menus/${menuId}/sections/${sectionId}/`, { method: 'PATCH', body });

export const deleteSection = (menuId, sectionId) =>
  apiFetch(`/api/menus/${menuId}/sections/${sectionId}/`, { method: 'DELETE' });

// order: [sectionId, ...]
export const reorderSections = (menuId, order) =>
  apiFetch(`/api/menus/${menuId}/sections/reorder/`, { method: 'POST', body: { order } });

// ── Печать / экспорт ─────────────────────────────────────────────────────────
// fmt: 'html' | 'pdf' | 'docx'. Параметр — fmt (не format: зарезервирован DRF).
// Возвращает относительный URL (Vite проксирует /api) — открывать window.open/iframe.
export const getMenuPrintUrl = (id, fmt = 'html', { hideStoplist = false } = {}) => {
  const q = new URLSearchParams({ fmt });
  if (hideStoplist) q.set('hide_stoplist', '1');
  return `/api/menus/${id}/print/?${q.toString()}`;
};
